import React from 'react'
import SeoLandingPage from './SeoLandingPage'
import { SEO_KEYWORDS_EXTRA } from '../../seo/extraKeywords'

export default function BedAdmissionMayurbhanj() {
  return (
    <SeoLandingPage
      path="/b-ed-admission-mayurbhanj"
      title="B.Ed Admission Mayurbhanj | Thakurmunda, Karanjia, Andapur & Nearby | Coaching"
      description="B.Ed admission counselling + coaching for Mayurbhanj — Thakurmunda, Karanjia, Andapur, Chhenapadi, Baripada & nearby. Documents, books, online classes + Bhadrak office support."
      keywords={`B.Ed admission Thakurmunda, B.Ed coaching Thakurmunda, B.Ed admission Karanjia, B.Ed admission Andapur Mayurbhanj, B.Ed coaching Andapur, B.Ed admission Chhenapadi, B.Ed Mayurbhanj district, best B.Ed institute Mayurbhanj, B.Ed Baripada, BP.Ed Mayurbhanj Odisha, B.Ed North Odisha Mayurbhanj, ${SEO_KEYWORDS_EXTRA}`}
      h1="B.Ed Admission in Mayurbhanj – Counselling + Coaching Support"
      intro="Students from Mayurbhanj district — including Thakurmunda, Karanjia, Andapur, Chhenapadi, Baripada and nearby blocks — can get B.Ed admission counselling, eligibility guidance, admission processing, study materials and online coaching. Offline support is available via our Bhadrak office when you need document or book help."
      bullets={[
        'B.Ed admission counselling for Mayurbhanj district',
        'Support for Thakurmunda, Karanjia, Andapur, Chhenapadi, Baripada and nearby areas',
        'Online coaching/classes + study material guidance',
        'Admission processing and form fill-up help',
        'Document checklist & verification support',
        'Book distribution support via office',
      ]}
      areaServed={[
        { '@type': 'AdministrativeArea', name: 'Mayurbhanj' },
        { '@type': 'Place', name: 'Thakurmunda' },
        { '@type': 'Place', name: 'Andapur' },
        { '@type': 'Place', name: 'Chhenapadi' },
        { '@type': 'City', name: 'Baripada' },
        { '@type': 'City', name: 'Karanjia' },
        { '@type': 'City', name: 'Bhadrak' },
        { '@type': 'City', name: 'Baripada' },
        { '@type': 'State', name: 'Odisha' },
      ]}
      faqs={[
        {
          q: 'Do you support students from Karanjia and other Mayurbhanj areas?',
          a: 'Yes. We support students across Mayurbhanj district including Karanjia and surrounding regions.',
        },
        {
          q: 'Is coaching available along with admission support?',
          a: 'Yes. We provide coaching support through online classes and study material guidance.',
        },
        {
          q: 'How do I start the admission process?',
          a: 'Call/WhatsApp us for counselling. We will guide you on eligibility, documents, steps and timelines.',
        },
      ]}
    />
  )
}
